import { isAlone } from "@/lib/utils";

const links = isAlone ? {
  customerServices: [
    { label: 'footer.faqs', path: '#' },
    { label: 'footer.track_order', path: '#' },
    { label: 'footer.returns', path: '#' },
    { label: 'footer.delivery', path: '#' },
    { label: 'footer.payment', path: '#' },
  ],
  about: [
    { label: 'footer.about_us', path: '#' },
    { label: 'footer.blog', path: '#' },
    { label: 'footer.privacy_policy', path: '#' },
    { label: 'footer.terms_conditions', path: '#' },
  ],
  connect: [
    { label: 'footer.facebook', path: 'https://facebook.com' },
    { label: 'footer.instagram', path: 'https://instagram.com' },
    { label: 'footer.linkedin', path: 'https://linkedin.com' },
  ],
} : {
  customerServices: [
    // { label: 'footer.faqs', path: '#' },
    // { label: 'footer.track_order', path: '#' },
    { label: 'footer.returns', path: '/return-policy' },
    { label: 'footer.refunds', path: '/refunds' },
    { label: 'footer.privacy_policy', path: '/privacy-policy' },
    { label: 'footer.shipping_policy', path: '/shipping-policy' },
    { label: 'footer.seller_service_agreement', path: '/seller-service-agreement' },

    // { label: 'footer.delivery', path: '#' },
    // { label: 'footer.payment', path: '#' },
  ],
  about: [
    { label: 'footer.about_us', path: '/about-us' },
    { label: 'footer.term_of_service', path: '/term-of-service' },
    // { label: 'footer.blog', path: '#' },
    // { label: 'footer.terms_conditions', path: '#' },
  ],
  connect: [
    // { label: 'footer.facebook', path: 'https://facebook.com' },
    // { label: 'footer.instagram', path: 'https://instagram.com' },
    // { label: 'footer.linkedin', path: 'https://linkedin.com' },
    { label: 'footer.contact_us', path: '/contact-us' },
  ],
};

export default links;
